import { CoralogixRum } from "@coralogix/browser";
import type { ClientOptions, StackFrame } from "@sentry/types";
import { getFramesFromEvent } from "@sentry/utils";

const THIRD_PARTY_DOMAINS = [
  "https://script.crazyegg.com",
  "https://www.googletagmanager.com",
  "https://www.gstatic.com",
];

const doesStacktraceContainThirdPartyDomain = (stacktrace: StackFrame[] | undefined) => {
  if (!stacktrace) return false;

  return stacktrace.some(frame =>
    THIRD_PARTY_DOMAINS.some(
      domain => frame.filename?.startsWith(domain) || frame.abs_path?.startsWith(domain)
    )
  );
};

const thirdPartyDomains: NonNullable<ClientOptions["beforeSend"]> = (event, hint) => {
  const frames = getFramesFromEvent(event);

  if (doesStacktraceContainThirdPartyDomain(frames)) {
    if (typeof hint.originalException === "object" && hint.originalException instanceof Error) {
      CoralogixRum.captureError(hint.originalException);
    }

    return null;
  }

  return event;
};

export { thirdPartyDomains };
